var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container has-text-centered my-6 px-5"},[_c('h1',{staticClass:"title is-size-5-mobile"},[_vm._v("Update your new password.")]),_c('ResetPasswordForm',{on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }